import {gql, useQuery, QueryHookOptions} from '@apollo/client';
import {AppConfigQuery} from '../types/graphql';

/**
 * Query to fetch the Nudge app config.
 */
export const APP_CONFIG = gql`
  query AppConfig {
    clientConfig {
      googleTranslateKey
      oauth2 {
        issuer
        scopes
        authEndpoint
        tokenEndpoint
        webClient {
          clientId
          redirectUrl
        }
        state
        accessType
      }
      style {
        login {
          logo
          bgColor
          textColor
          btnColor
          btnTextColor
          signInText
        }
        accentColor
      }
    }
  }
`;

/**
 * Hook to fetch app config.
 */
export const useAppConfig = (opts?: QueryHookOptions<AppConfigQuery>) =>
  useQuery<AppConfigQuery>(APP_CONFIG, opts);
